module.exports = __webpack_public_path__ + "img/progress-5.9c10e1fa.jpg";